import React, { useContext } from 'react'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import { withStyles, Typography } from '@material-ui/core'
import { CustomTextField } from '../../../components/CustomDisabledFields'
import { FieldArray } from 'react-final-form-arrays'
import { AuthContext, DateTimePicker } from 'elentari'
import { parseCpfOrCnpj, parsePlaca } from '../../../utils/Parse'
import ObservacaoField from '../../../components/ObservacaoField'
import EmpresaSelect from '../../Empresa/EmpresaSelect'
import IntegracaoKlios from './Klios/Klios'
import IntegracaoEagle from './Eagle/Eagle'

const styles = theme => ({
  root: {
    padding: theme.spacing(6)
  },
  marginTop: {
    marginTop: theme.spacing(5)
  }
})

function Blacklist(props) {
  const { name, index } = props
  return (
    <Grid container spacing={3}>
      {/* Half 0 */}
      <Grid item xs={12}>
        <Typography variant="subtitle1">{index + 1}° Blacklist</Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
        <Field
          fullWidth
          component={DateTimePicker}
          disabled
          label="Data"
          name={`${name}.data`}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Field
          fullWidth
          component={CustomTextField}
          disabled
          label="CPF / CNPJ"
          format={parseCpfOrCnpj}
          name={`${name}.cpfcnpj`}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <EmpresaSelect disabled name={`${name}.empresaId`} />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Field
          fullWidth
          component={CustomTextField}
          disabled
          format={parsePlaca}
          label="Placa"
          name={`${name}.placa`}
        />
      </Grid>
      <Grid item xs={12} sm={9}>
        <Field
          fullWidth
          component={CustomTextField}
          disabled
          label="Motivo"
          name={`${name}.motivo`}
        />
      </Grid>
      <Grid item xs={12}>
        <Field
          fullWidth
          component={CustomTextField}
          disabled
          label="Descrição"
          name={`${name}.descricao`}
        />
      </Grid>
    </Grid>
  )
}

function Bloqueio(props) {
  const { name, index } = props
  return (
    <Grid container spacing={3}>
      {/* Half 0 */}
      <Grid item xs={12}>
        <Typography variant="subtitle1">{index + 1}° Bloqueio</Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={6}>
          <Grid item xs={12} sm={6}>
            <Field
              fullWidth
              component={DateTimePicker}
              disabled
              label="Data Bloqueio"
              name={`${name}.dataBloqueio`}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <EmpresaSelect disabled name={`${name}.empresaId`} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={6}>
          <Grid item xs={12} sm={6}>
            <Field
              fullWidth
              component={CustomTextField}
              disabled
              format={parseCpfOrCnpj}
              label="CPF / CNPJ"
              name={`${name}.cpfcnpj`}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field
              fullWidth
              component={CustomTextField}
              disabled
              format={parsePlaca}
              label="Placa"
              name={`${name}.placa`}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={6}>
          <Grid item xs={12} sm={6}>
            <Field
              fullWidth
              component={CustomTextField}
              disabled
              label="Nome / Razão Social"
              name={`${name}.nomeRazaoSocial`}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field
              fullWidth
              component={CustomTextField}
              disabled
              label="Apelido / Nome Fantasia"
              name={`${name}.apelidoNomeFantasia`}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={6}>
          <Grid item xs={12} sm={6}>
            <Field
              fullWidth
              component={CustomTextField}
              disabled
              label="Motivo Bloqueio"
              name={`${name}.motivoBloqueio`}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field
              fullWidth
              component={CustomTextField}
              disabled
              label="Motivo Desbloqueio"
              name={`${name}.motivoDesbloqueio`}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

function BlacklistsBloqueiosForm({ values, classes, cannotUpdate, ...props }) {
  const { user } = useContext(AuthContext)

  return (
    <div className={classes.root}>
      {user.realm === 'gestor' ? (
        <Typography align="center" className={classes.marginTop} variant="h5">
          Informações exclusivas do time da Central de Cadastros
        </Typography>
      ) : (
        <>
          <FieldArray name="blacklists">
            {({ fields }) => (
              <div>
                <Typography className={classes.marginTop} variant="h6" gutterBottom>
                  Blacklist
                </Typography>
                {!fields.length && (
                  <Typography>Nenhum blacklist encontrado</Typography>
                )}
                {fields.map((name, index) => (
                  <Blacklist key={name} name={name} index={index} />
                ))}
              </div>
            )}
          </FieldArray>
          <FieldArray name="bloqueios">
            {({ fields }) => (
              <div>
                <Typography className={classes.marginTop} variant="h6" gutterBottom>
                  Bloqueios manuais
                </Typography>
                {!fields.length && (
                  <Typography>Nenhum bloqueio manual encontrado</Typography>
                )}
                {fields.map((name, index) => (
                  <Bloqueio key={name} name={name} index={index} />
                ))}
              </div>
            )}
          </FieldArray>

          <div className={classes.marginTop}>
            <IntegracaoKlios solicitacaoId={values.id} />
          </div>

          <div className={classes.marginTop}>
            <IntegracaoEagle solicitacaoId={values.id} />
          </div>

          <div className={classes.marginTop}>
            <ObservacaoField
              value={values.notaInterna}
              title="Nota Interna"
              placeholder=""
              name="novaNotaInterna"
              disabled={cannotUpdate}
            />
          </div>
          <div className={classes.marginTop}>
            <ObservacaoField
              value={values.observacaoBlacklistBloqueios}
              title="Observações Blacklist / Bloqueios"
              placeholder="Escreva aqui observações sobre os Blacklist / Bloqueios"
              name="novaObservacaoBlacklistBloqueios"
              disabled={cannotUpdate}
            />
          </div>
        </>
      )}
    </div>
  )
}

export default withStyles(styles)(BlacklistsBloqueiosForm)
